exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".AllergyField__container__WZGs2{width:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.AllergyField__container__WZGs2>div{-ms-flex:.49;flex:.49}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/AllergyField.scss"],"names":[],"mappings":"AAEA,gCACE,WAAW,AACX,oBAAa,AAAb,aAAa,AACb,sBAAmB,AAAnB,mBAAmB,AACnB,sBAA8B,AAA9B,6BAA8B,CAK/B,AATD,oCAOI,aAAS,AAAT,QAAS,CACV","file":"AllergyField.scss","sourcesContent":["@import '../../styles/theme.scss';\n\n.container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  > div {\n    flex: .49;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "AllergyField__container__WZGs2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/AllergyField.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/AllergyField.scss
// module chunks = 0